import { QuestionCircle } from "@styled-icons/fa-solid/QuestionCircle";
import styled from "styled-components";
import ReactTooltip from "../ReactTooltip";

const HelpIcon = styled(QuestionCircle)`
  && {
    margin-left: 4px;
  }
`;

const HelpTooltip = ({ id, content }) => (
  <>
    <HelpIcon data-for={id} data-tip={content} />
    <ReactTooltip place="right" effect="solid" id={id} html={true} />
  </>
);

export default HelpTooltip;
